export enum FeatureToggleFlags {
  LINKEDIN_OUTREACH = 'linkedin-outreach',
  V2_BANNER = 'v2-banner',
  RANKING_CONFIGURATION = 'ranking-configuration',
  CAREER_PAGE = 'career-page',
  LANGUAGE_SWITCHER = 'language-switcher'
}
